import { render, staticRenderFns } from "./RatingView.vue?vue&type=template&id=7b9e616c&scoped=true"
import script from "./RatingView.vue?vue&type=script&lang=js"
export * from "./RatingView.vue?vue&type=script&lang=js"
import style0 from "./RatingView.vue?vue&type=style&index=0&id=7b9e616c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9e616c",
  null
  
)

export default component.exports